import { render, staticRenderFns } from "./CourseTestDone.vue?vue&type=template&id=62dfe3bf&scoped=true&"
import script from "./CourseTestDone.vue?vue&type=script&lang=js&"
export * from "./CourseTestDone.vue?vue&type=script&lang=js&"
import style0 from "./CourseTestDone.vue?vue&type=style&index=0&id=62dfe3bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dfe3bf",
  null
  
)

export default component.exports